import {get} from '@/utils/fetch';
import {ASYNC_UILS} from '@/dicts/fetchUrls';

const prefixAPI = process.env.PREFIX_ASYNC_API;

export interface IdentifyResult {
    /** true 通过认证， false没有通过认证 * */
    pass: boolean;
}

/** 医生认证状态 * */
export const requestIdentifyStatus = async (): Promise<IdentifyResult> => {
    return await get<IdentifyResult>(`${prefixAPI}${ASYNC_UILS.USER_CHECK}`);
};
